"use client";

import React from "react";

interface HeroDotsProps {
  total: number;
  activeIndex: number;
  onDotClick: (index: number) => void;
}

const HeroDots: React.FC<HeroDotsProps> = ({
  total,
  activeIndex,
  onDotClick,
}) => {
  if (total <= 1) return null;

  return (
    <div 
      className="absolute bottom-4 left-1/2 -translate-x-1/2 z-10 flex gap-2"
      role="tablist"
      aria-label="Slideshow pagination"
    >
      {Array.from({ length: total }).map((_, idx) => {
        const isActive = idx === activeIndex;
        return (
          <button
            key={idx}
            onClick={(e) => {
              e.preventDefault();
              onDotClick(idx);
            }}
            className={`h-2 rounded-full transition-all duration-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-[#D97706] ${
              isActive 
                ? "bg-[#D97706] w-4" 
                : "bg-white/40 hover:bg-white/70 w-2"
            }`}
            role="tab"
            aria-selected={isActive}
            aria-label={`Go to slide ${idx + 1}`}
            tabIndex={0}
          />
        );
      })}
    </div>
  );
};

export default React.memo(HeroDots);
